export default [
  {
    path: '/auth/pages',
    name: 'pages',
    component: () => import('@/views/uot/pages.vue'),
  },
  {
    path: '/auth/user-list',
    name: 'users-list',
    component: () => import('@/views/uot/users.vue'),

  },
  {
    path: '/auth/roles',
    name: 'roles',
    component: () => import('@/views/uot/roles.vue'),
  },
  {
    path: '/auth/kafala',
    name: 'kafala',
    component: () => import('@/views/uot/kafala.vue'),
  },
  {
    path: '/auth/departments',
    name: 'departments',
    component: () => import('@/views/uot/department.vue'),

  },
  {
    path: '/auth/types',
    name: 'types',
    component: () => import('@/views/uot/types.vue'),

  },
  {
    path: '/auth/welcome',
    name: 'welcome',
    component: () => import('@/views/uot/welcome.vue'),
    meta: {
      layout: 'full',
    },
  },
]